/* eslint-disable */
export default {
  topic: 'Meeting title',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
